import type { AbsencePeriod, Dev } from '../../types/domain';
import { addDays, dateFromIso, getHolidaysCached, isoStr, isWE } from '../dates';
import { fmtDate } from '../format';
import { dayCoverage } from './coverage';

// Période lisible d'une absence, sans le type (utilisé quand le type a déjà sa propre colonne/pastille).
export function formatAbsencePeriod(a: AbsencePeriod): string {
  const startHalf = a.debut_half || 'am',
    endHalf = a.fin_half || 'pm';
  if (a.debut === a.fin)
    return `Le ${fmtDate(a.debut)}${startHalf === 'pm' ? ' (ap-m)' : endHalf === 'am' ? ' (matin)' : ''}`;
  return `Du ${fmtDate(a.debut)}${startHalf === 'pm' ? ' (ap-m)' : ''} au ${fmtDate(a.fin)}${endHalf === 'am' ? ' (matin)' : ''}`;
}

// Nombre total de jours (demi-journées comprises) couverts par une absence, hors week-ends/fériés —
// même logique que syncAbsenceTimesheets, mais agrégée sur toute la période au lieu d'un jour donné.
export function absenceTotalDays(a: AbsencePeriod): number {
  let cur = dateFromIso(a.debut);
  const end = dateFromIso(a.fin);
  let jours = 0;
  while (cur <= end) {
    const iso = isoStr(cur);
    if (!isWE(cur) && !getHolidaysCached(cur.getFullYear()).has(iso)) {
      const cov = dayCoverage([a], iso);
      jours += (cov.am ? 0.5 : 0) + (cov.pm ? 0.5 : 0);
    }
    cur = addDays(cur, 1);
  }
  return Math.round(jours * 10) / 10;
}

// Solde CP après acceptation d'une demande en attente, affiché au valideur avant qu'il décide. Le
// solde lui-même est tenu en base (+2,08 j le 1er du mois, congés payés retirés à l'acceptation,
// migration 020) ; il peut devenir négatif, le valideur est alors alerté (isLeaveBalanceNegative).
// Arrondi au centième : le crédit mensuel (2,08) en a deux décimales.
export function projectedLeaveBalance(dev: Pick<Dev, 'soldeCp'>, absence: AbsencePeriod): number {
  return Math.round(((dev.soldeCp || 0) - absenceTotalDays(absence)) * 100) / 100;
}
